import { Link, NavLink, Routes, Route } from "react-router-dom";
import { LayoutGrid, Users, GalleryHorizontal, Boxes, Scale, Link2, Image, Search, Megaphone, LogOut, Home, Settings, Cookie } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import Dashboard from "./Dashboard";
import UsersAdmin from "./UsersAdmin";
import BannersAdmin from "./BannersAdmin";
import BrandsAdmin from "./BrandsAdmin";
import LegalAdmin from "./LegalAdmin";
import LinksAdmin from "./LinksAdmin";
import MediaAdmin from "./MediaAdmin";
import SeoAdmin from "./SeoAdmin";
import IntranetAdmin from "./IntranetAdmin";
import ConfigAdmin from "./ConfigAdmin";
import ConsentsAdmin from "./ConsentsAdmin";

const MODULES = [
  { to: "/matriz", icon: LayoutGrid, label: "Panel", end: true },
  { to: "/matriz/usuarios", icon: Users, label: "Usuarios", adminOnly: true },
  { to: "/matriz/banners", icon: GalleryHorizontal, label: "Banners" },
  { to: "/matriz/ecosistema", icon: Boxes, label: "Ecosistema" },
  { to: "/matriz/legal", icon: Scale, label: "Área Legal", adminOnly: true },
  { to: "/matriz/consentimientos", icon: Cookie, label: "Consentimientos", adminOnly: true },
  { to: "/matriz/enlaces", icon: Link2, label: "Enlaces" },
  { to: "/matriz/multimedia", icon: Image, label: "Multimedia" },
  { to: "/matriz/seo", icon: Search, label: "SEO" },
  { to: "/matriz/intranet", icon: Megaphone, label: "Intranet" },
  { to: "/matriz/configuracion", icon: Settings, label: "Configuración", adminOnly: true },
];

export default function MatrizLayout() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-[#F7F8FA] text-[#0B1220] flex" data-testid="matriz-layout">
      <aside className="w-56 border-r border-slate-200 bg-white flex flex-col fixed inset-y-0 z-40">
        <div className="h-14 flex items-center px-4 border-b border-slate-200">
          <span className="font-display font-black text-[#5698C7] text-sm tracking-tight">MATRIZ</span>
          <span className="font-mono-tech text-[9px] text-slate-400 tracking-widest ml-2">v1.0</span>
        </div>
        <nav className="flex-1 py-4 overflow-y-auto">
          {MODULES.filter((m) => !m.adminOnly || user?.role === "admin").map((m) => (
            <NavLink key={m.to} to={m.to} end={m.end} data-testid={`matriz-nav-${m.label.toLowerCase().replace(/\s|á/g, (c) => (c === "á" ? "a" : "-"))}`}
              className={({ isActive }) => `flex items-center gap-3 px-4 py-2.5 text-xs transition-colors duration-200 border-l-2 ${isActive ? "border-[#5698C7] text-[#5698C7] bg-[#5698C7]/5" : "border-transparent text-slate-500 hover:text-[#0B1220]"}`}>
              <m.icon size={14} strokeWidth={1.5} /> {m.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-slate-200 p-4 space-y-2">
          <span className="block text-[10px] text-slate-400 truncate">{user?.email}</span>
          <div className="flex items-center gap-4">
            <Link to="/" className="text-slate-500 hover:text-[#5698C7] transition-colors duration-200" data-testid="matriz-home-link"><Home size={14} /></Link>
            <Link to="/intranet" className="text-slate-500 hover:text-[#5698C7] transition-colors duration-200" data-testid="matriz-intranet-link"><Megaphone size={14} /></Link>
            <button onClick={logout} className="text-slate-500 hover:text-red-600 transition-colors duration-200" data-testid="matriz-logout-btn"><LogOut size={14} /></button>
          </div>
        </div>
      </aside>
      <main className="flex-1 ml-56 p-8">
        <Routes>
          <Route index element={<Dashboard />} />
          {user?.role === "admin" && <Route path="usuarios" element={<UsersAdmin />} />}
          <Route path="banners" element={<BannersAdmin />} />
          <Route path="ecosistema" element={<BrandsAdmin />} />
          {user?.role === "admin" && <Route path="legal" element={<LegalAdmin />} />}
          {user?.role === "admin" && <Route path="consentimientos" element={<ConsentsAdmin />} />}
          <Route path="enlaces" element={<LinksAdmin />} />
          <Route path="multimedia" element={<MediaAdmin />} />
          <Route path="seo" element={<SeoAdmin />} />
          <Route path="intranet" element={<IntranetAdmin />} />
          {user?.role === "admin" && <Route path="configuracion" element={<ConfigAdmin />} />}
        </Routes>
      </main>
    </div>
  );
}
